"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubPageSchema = void 0;
exports.SubPageSchema = {
    "$id": "https://www.redbull.com/schemas/attributes/sub-page.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "SubPage",
    "description": "Add a sub-page (editorial container)",
    "type": "object",
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "attributes:sub-page"
            ]
        },
        "label": {
            "type": "string"
        },
        "subPage": {
            "$ref": "https://www.redbull.com/schemas/reference/content/event-details.schema.json"
        }
    },
    "required": [
        "label",
        "subPage",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3ViLXBhZ2Uuc2NoZW1hLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL21vZHVsZXMvYXR0cmlidXRlcy9zdWItcGFnZS5zY2hlbWEudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQWEsUUFBQSxhQUFhLEdBQUc7SUFDM0IsS0FBSyxFQUFFLGlFQUFpRTtJQUN4RSxTQUFTLEVBQUUsOENBQThDO0lBQ3pELE9BQU8sRUFBRSxTQUFTO0lBQ2xCLGFBQWEsRUFBRSxzQ0FBc0M7SUFDckQsTUFBTSxFQUFFLFFBQVE7SUFDaEIsWUFBWSxFQUFFO1FBQ1osTUFBTSxFQUFFO1lBQ04sTUFBTSxFQUFFLFFBQVE7WUFDaEIsTUFBTSxFQUFFO2dCQUNOLHFCQUFxQjthQUN0QjtTQUNGO1FBQ0QsT0FBTyxFQUFFO1lBQ1AsTUFBTSxFQUFFLFFBQVE7U0FDakI7UUFDRCxTQUFTLEVBQUU7WUFDVCxNQUFNLEVBQUUsNkVBQTZFO1NBQ3RGO0tBQ0Y7SUFDRCxVQUFVLEVBQUU7UUFDVixPQUFPO1FBQ1AsU0FBUztRQUNULE1BQU07S0FDUDtDQUNGLENBQUEifQ==